function mass_delete(checkboxElm, buttonSelector, url, object) {
    const $ = jQuery.noConflict();

    const name = jQuery(checkboxElm).attr('name').split('[')[0] + '\[\]';
    const table = jQuery(checkboxElm).parents('table');
    const checkedItems = table.find('input[name="' + name + '"]:checked');
    const ids = [];
    checkedItems.each(function () {
        ids.push(jQuery(this).val());
    });

    const button = table.parent().find(buttonSelector);
    button.toggle(ids.length > 0);

    button.unbind('click').click(function () {
        const count = ids.length;
        confirm(`Weet u zeker dat u ${count === 1 ? 'het' : `de ${count}`} geselecteerde ${count === 1 ? 'item' : 'items'} wilt verwijderen?`, function() {
            $('body').isLoading('dark');

            $.ajax({
                url: url,
                data: { ids },
                type: 'DELETE',
                success: function(data) {
                    $('body').doneLoading();
                    const reloadTables = [];
                    ids.forEach(function(id) {
                        $('.reveal').trigger('onDelete-' + object + '-' + id);
                        $('[data-id="' + id + '"][data-object-type="' + object + '"]').each(function() {
                            const tr = $(this);
                            const table = tr.parents('table');

                            const checkWholeTable = table.find('.check-whole-table');
                            if (checkWholeTable.is(':checked')) {
                                checkWholeTable.prop('checked', false).trigger('change');
                            }


                            const selector = `table[data-reloadable-url="${table.attr('data-reloadable-url')}"]`;
                            if (reloadTables.indexOf(selector) === -1) {
                                reloadTables.push(selector);
                            }
                        });
                    });
                    reloadTables.forEach(function (selector) {
                        const table = jQuery(selector);
                        table.reloadThisElement();
                    });
                    squde_flash(`${count === 1 ? 'Het geselecteerde item' : 'De geselecteerde items'} is verwijderd.`, 'success');
                },
                error: function(e) {
                    $('body').doneLoading();
                    squde_flash("Er ging helaas iets mis.", "alert");
                }
            });

        }, function() {
            // noop
        }, true);
        return false;
    });
}
